import { render } from "./MenuDrawer.vue?vue&type=template&id=044874f0&scoped=true"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"

import "./MenuDrawer.vue?vue&type=style&index=0&id=044874f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044874f0"]])

export default __exports__